import appReducer from 'reducers/app-reducer';
import authReducer from 'reducers/auth-reducer';
import brandReducer from 'reducers/brand-reducer';
import dayReportReducer from 'reducers/day-report-reducer';
import royaltyReportReducer from 'reducers/royalty-report-reducer';
import profileReducer from 'reducers/profile-reducer';
import sessionReducer from 'reducers/session-reducer';
import storeReducer from 'reducers/store-reducer';
import storeUsersReducer from 'reducers/store-users-reducer';
import userReducer from 'reducers/user-reducer';
import taxReducer from 'reducers/tax-reducer';
import updateUserReducer from 'reducers/update-user-reducer';
import updateStoreReducer from 'reducers/update-store-reducer';
import dashboardReducer from 'reducers/dashboard-reducer';
import shiftReportReducer from 'reducers/shift-report-reducer';

const reducers = {
  appReducer,
  authReducer,
  profileReducer,
  storeReducer,
  userReducer,
  brandReducer,
  sessionReducer,
  storeUsersReducer,
  dayReportReducer,
  taxReducer,
  updateUserReducer,
  updateStoreReducer,
  dashboardReducer,
  shiftReportReducer,
  royaltyReportReducer,
};

export default reducers;
